<template>
  <div>
    <div v-if="!isPC" class="detailPage" :class="{'hashead hasservice':estateVo}">
      <div class="loading" v-if="houseArr.length==0"><i class="el-icon-loading"></i></div>
      <LeaveTel ref="LeaveTel" :service="true" :estate="[estateVo.phone2,estateVo.pkId,estateVo.name,'户型']" v-if="estateVo.name"></LeaveTel>
      <WapHeader :title="title" :showhome="true"></WapHeader>
      <div class="box">
        <div class="banner" @click="openAlbum=true">
          <!-- <img v-lazy="houseTypeVo.imgPath +'&type=1'" /> -->
          <img v-lazy:background-image="{src:houseTypeVo.imgPath +'&type=1',error:'../static/default-house.png'}" />
          <span class="imgcount" v-if="mfangPhotoList.length>0">相册1/{{mfangPhotoList.length}}</span>
        </div>
        <div class="housetypedata">
          <p class="httitle" v-if="title">{{title}}<span class="httype" :class="{'r':houseTypeVo.status=='售罄'}">{{houseTypeVo.status}}</span></p>
          <span class="mprice httax" v-if="houseTypeVo.houseTaxPrice">返现:<b>{{houseTypeVo.houseTaxPrice}}</b>元</span>
          <p class="mprice" v-if="houseTypeVo.totalPrice!=null&&houseTypeVo.totalPrice!=0"><b>{{houseTypeVo.totalPrice}}</b>万元</p>
          <p class="mprice" v-else>售价待定</p>
          <p class="ename">{{estateVo.name}} {{houseTypeVo.name}}</p>
          <div class="b-tag" v-if="houseTypeTagsList.length>0">
            <span v-for="(item, index) in houseTypeTagsList" :key="index">{{item.name}}</span>
          </div>
          <div class="colsbox" v-if="houseTypeVo.length!=0">
            <span><b>{{houseTypeVo.acreage}}㎡</b>面积</span><span><b>{{houseTypeVo.type}}</b>属性</span><span><b>{{houseArr.decorate}}</b>装修</span><span><b>{{houseTypeVo.direction}}</b>朝向</span>
          </div>
          <div class="leave-box" @click="leaveClick(16)"><span>获取楼盘底价信息</span></div>
          <div v-if="commercialLanObj.length!=0 && houseTypeVo.totalPrice!=null && houseTypeVo.totalPrice!=0">
            <p class="btitle">商贷详情</p>
            <div class="lendbox">
              <span><label><b>{{commercialLanObj.sfPrice}}</b>万</label>首付</span><span><label><b>{{commercialLanObj.zePrice}}</b>万</label>贷款总额</span><span><label><b>{{commercialLanObj.ygPrice}}</b>元</label>月供({{commercialLanObj.monthYears}}年)</span>
            </div>
            <p @click="$router.push({path:'/calculate'})" class="hlink">房贷计算器>></p>
            <div v-if="!isPC" class="leave-box" @click="leaveClick(17)"><span>房贷政策咨询服务</span></div>
          </div>
          <EDAdviser :isPC="false" :adviserVO="adviserDTO" @leaveCallClick="leaveCallClick" @leaveClick="leaveClick"></EDAdviser>
          <div v-if="analysisList.length!=0">
            <p class="btitle">户型解析</p>
            <div class="buildintro">
              <p v-for="(item,index) in analysisList" :key="index"><label>{{item.name}}：</label>{{item.desc}}</p>
              <div class="leave-box" @click="leaveClick(18)"><span>户型细节一手掌握</span></div>
            </div>
          </div>
          <div class="relativebox" v-if="otherHouseList.length!=0" id="htype">
            <p class="btitle">其他户型</p>
            <div class="sizewrap clearfix" v-if="otherHouseList">
              <div :style="$store.state.domainIndex!=3?'width:'+otherHouseList.length*172+'px':''">
              <div class="sizeitem" v-for="(item, index) in otherHouseList" :key="index" @click="$router.push({ name:'houseType',query:{eid:estateVo.pkId, hid:item.pkId} });reload()">
                <!-- <img v-lazy="item.imgPath +'&type=1&size=240x180'" /> -->
                <img v-lazy:background-image="{src:item.imgPath +'&type=1&size=240x180',error:'../static/default-house.png'}" />
                <div>
                  <div class="b-tag"><span :class="item.status=='售罄'?'r':'g'">{{item.status}}</span><span :class="item.type=='商铺'||item.type=='写字楼'?'b':'y'">{{item.type}}</span></div>
                  <b>{{item.roomCount}}室{{item.hallCount}}厅{{item.lavatoryCount}}卫</b>
                  <span class="si-area">{{item.acreageType}}{{item.acreage}}㎡</span>
                  <span class="si-tprice" v-if="item.totalPrice!=null&&item.totalPrice!=0">总价:<i>{{item.totalPrice}}</i>万元</span>
                  <span class="si-tprice" v-else>售价待定</span>
                  <span class="mprice si-tax" v-if="item.houseTaxPrice">返现:<b>{{item.houseTaxPrice}}</b>元</span>
                </div>
              </div>
              </div>
            </div>
            <div class="leave-box" @click="leaveClick(19)"><span>了解剩余房源情况</span></div>
          </div>
          <!-- <div class="likewrap" v-if="myBeLikeHouseList.length>0">
            <p class="btitle">你可能喜欢</p>
            <div class="similarwrap">
              <ul class="clearfix" :style="'width:'+(myBeLikeHouseList.length*140-10)+'px'">
                <li :key="index" v-for="(item,index) in myBeLikeHouseList" @click="$router.push({ name:'houseType',query:{eid:estateVo.pkId, hid:item.pkId} });reload()">
                  <el-image :src="item.imgPath" fit="cover" lazy></el-image>
                  <p class="s-price">{{item.totalPrice}}万</p>
                  <p class="s-house">{{item.roomCount}}房{{item.hallCount}}厅{{item.lavatoryCount}}卫 {{item.acreage}}㎡</p>
                  <p class="s-title">{{item.fkNameEastate}}</p>
                </li>
              </ul>
            </div>
          </div> -->
        </div>
      </div>
      <Footer></Footer>
      <div v-if="openAlbum" class="popwrap">
        <div class="popbox">
          <span @click.self="openAlbum=false" class="el-icon-error"></span>
          <div class="estateInfo">
            <p class="etitle">{{estateVo.name}}</p>
            <p class="ephone" v-if="estateVo.phone2">{{estateVo.phone2}}</p>
          </div>
          <Album :aId="houseTypeVo.pkId"></Album>
        </div>
      </div>
    </div>
    <div v-else>为了不影响体验，请用移动端查看。</div>
  </div>
</template>

<script>
import Global from '@/components/public/Global'
import WapHeader from '@/components/public/WapHeader'
import LeaveTel from '@/components/public/LeaveTel'
import Footer from '@/components/public/Footer'
import Album from '@/components/Album'
export default {
  name: 'housetype',
  inject:['reload'],
  components: {
    'WapHeader':WapHeader,
    'LeaveTel':LeaveTel,
    'Footer':Footer,
    'Album':Album,
    EDAdviser: resolve => require(['@/components/public/EDAdviser'],resolve),
  },
  data () {
    return {
      isPC:this.$store.state.isPC,
      houseArr:[],
      title:'',
      estateVo:[],
      houseTypeVo:[],
      mfangPhotoList:[],
      houseTypeTagsList:[],
      commercialLanObj:[],
      adviserDTO:null,
      analysisList:[],
      otherHouseList:[],
      myBeLikeHouseList:[],
      openAlbum:false,
      bdmapChannel: Global.channel_bdmap
    }
  },
  computed:{
    listenIsPC(){
      return this.$store.state.isPC;
    }
  },
  watch:{
    listenIsPC:function(boo){
      this.isPC = this.$store.state.isPC;
    }
  },
  mounted() {
    this.getHouseTypeDetail();
  },
  methods:{
    getHouseTypeDetail(){
      document.getElementById('app').scrollIntoView();
      let url = '/api/apartment/getHouseTypeDetail?estateId='+this.$route.query.eid+'&houseId='+this.$route.query.hid;
      let channel = sessionStorage.getItem("channel");
      if (channel && channel.indexOf(this.bdmapChannel) !== -1) {
        url += '&channel=' + this.bdmapChannel;;
      }
      this.$http.get(url).then((response)=>{
        this.houseArr=response.data.result;
        this.estateVo=this.houseArr.estateVo;
        this.houseTypeVo=this.houseArr.houseTypeVo;
        this.title=this.houseTypeVo.roomCount+'室'+this.houseTypeVo.hallCount+'厅'+this.houseTypeVo.lavatoryCount+'卫';
        this.mfangPhotoList=this.houseArr.mfangPhotoList;
        this.houseTypeTagsList=this.houseArr.houseTypeTagsList;
        this.commercialLanObj=this.houseArr.commercialLanObj;
        this.adviserDTO=this.houseArr.adviserDTO;
        this.analysisList=this.houseArr.analysisList;
        this.otherHouseList=this.houseArr.otherHouseList;
        this.myBeLikeHouseList=this.houseArr.myBeLikeHouseList;
        // 微信获取密钥分享
        this.getSignatureShare();
      }).catch((response)=>{
        console.log(response)
      })
    },
    leaveClick(index){
      this.$refs.LeaveTel.leaveClick(index,this.estateVo.pkId,this.estateVo.name,'户型');
    },
    leaveCallClick(phone,eid,ename){
      if(eid==undefined){
        eid=this.$route.query.eid
      }
      if(ename==undefined){
        ename=this.estateVo.name
      }
      this.$refs.LeaveTel.leaveCallClick(phone,eid,ename,'户型');
    },
    // 微信获取密钥分享
    getSignatureShare(){
      var shareObj = {
        link: window.location.href,
        title: document.title+'-户型详情',
        desc: this.title,
        imgUrl: this.houseTypeVo.imgPath,
        logoIndex: this.$store.state.domainIndex
      };
      this.$http.get('/api/wechat/getSignatureInfo?url='+shareObj.link).then((response)=>{
        if(response && response.data.result){
          this.share.weixinShare(shareObj, response.data.result);
        }
      }).catch((response)=>{
        console.log(response)
      })
    },
  }
}
</script>

<style scoped>
  .banner{height:220px;position:relative;}
  /*.banner img{display:block;width:100%;}*/
  .banner img{width:100%;height:100%;background-size:cover;background-repeat:no-repeat;background-position:center;}
  .imgcount{position:absolute;z-index:2;bottom:15px;right:15px;color:#fff;background:rgba(0, 0, 0, 0.3);border-radius:2px;padding:5px 8px;font-size:12px;line-height:18px;}
  .housetypedata{padding:15px;background:#fff;line-height:24px;}
  .httitle{font-size:20px;font-weight:700;color:#333;}
  .httype{font-size:12px;display:inline-block;line-height:23px;height:23px;padding:0 6px;border-radius:2px;margin-top:1px;margin-left:10px;background:rgba(0,222,49,0.1);color:#00DE31;vertical-align:top;font-weight:400;}
  .httype.r{background:rgba(255,77,48,0.2);color:#FF4D30}
  .mprice{margin-top:7px;}
  .mprice b{font-size:20px;}
  .ename{margin-top:2px}
  .b-tag span{font-size:12px;display:inline-block;line-height:23px;height:23px;padding:0 6px;border-radius:2px;margin-top:6px;background:#f3f3f3;color:#9E9EAA;}
  .colsbox{text-align:center;margin:18px -15px 0;}
  .colsbox span{color:#888;width:25%;font-size:12px;display:inline-block;}
  .colsbox b{display:block;font-size:18px;height:24px;overflow:hidden;color:#555;}
  .leave-box{margin-top:20px;}
  .btitle{font-size:18px;margin-top:30px;color:#2e303a;line-height:30px;height:30px;}
  .btitle:before{content:"";width:4px;height:25px;background:#ffd03d;float:left;margin:2px 11px 0 -15px;}
  .lendbox{padding:15px 0;}
  .lendbox span{width:33.33%;text-align:center;font-size:12px;color:#999;display:inline-block;}
  .lendbox label{display:block;color:#333;}
  .lendbox b{font-size:20px;display:inline;}
  .hlink{color:#3090e9;text-align:center;font-weight:700;}
  .guwenitem{background:#f8f7fa;padding:22px 80px 19px 83px;position:relative;border-radius:8px;margin-top:15px;min-height:48px;}
  .gwimg{position:absolute;left:20px;top:20px;width:48px;height:48px;border-radius:50%;}
  .gwname{line-height:21px;color:#292929;font-size:17px;margin-bottom:6px;}
  .gwintro{font-size:12px;line-height:20px;color:#2e2e2e;margin-right:10px;}
  .gwintro em{color:#85847e;font-style:normal;}
  .swtell{position:absolute;right:20px;top:50%;margin-top:-20px;border-radius:50%;text-align:center;width:40px;height:40px;background:linear-gradient(90deg, #ff4d30 0%,#ff845e 100%);box-shadow:0 2px 4px 0 rgba(255,101,67,.46);}
  .swtell .m-icon{width:20px;height:20px;background-position:-201px -21px;margin-top:7px;transform: scale(0.8);}
  .buildintro{padding-top:12px;}
  .buildintro p{position:relative;line-height:20px;min-height:20px;padding:3px 0 3px 60px;}
  .buildintro label{position:absolute;top:3px;left:0;color:#a1a1a1;width:0;text-align:center;width:60px;}
  .sizewrap{line-height:20px;}
  .sizewrap{overflow:hidden;position:relative;}
  .sizeitem{padding:0 0 0 105px;position:relative;height:68px;overflow:hidden;margin-top:15px;}
  .sizeitem img{position:absolute;left:1px;top:1px;width:88px;height:66px;box-shadow:0 0 1px #bbb;border-radius:4px;overflow:hidden;background-size:contain;}
  .sizeitem .b-tag{position:absolute;right:0;top:1px;}
  .sizeitem .b-tag span{margin-top:0;line-height:20px;height:20px;}
  .sizeitem .b-tag .y{background:rgba(255,216,0,.1);color:#FFD800;}
  .sizeitem .b-tag .b{background:rgba(48,144,233,.1);color:#3090E9;}
  .sizeitem .b-tag .g{background:rgba(0,222,49,.1);color:#00DE31;}
  .sizeitem .b-tag .r{background:rgba(255,77,48,.2);color:#FF4D30;}
  .sizeitem p{line-height:20px;font-size:12px;}
  .sizeitem b{color:#2E2E2E;font-size:17px;font-weight:700;display:block;line-height:24px;}
  .si-area{display:block;color:#88888A;margin:4px 0 2px;}
  .si-tprice{color:#F44336;height:20px;display:inline-block;}
  .si-tprice i{font-size:16px;margin-right:1px;font-weight:700;}
  .similarwrap{-webkit-overflow-scrolling:touch;overflow:auto;padding-top:15px;}
  .similarwrap li{float:left;width:130px;line-height:20px;position:relative;}
  .similarwrap li+li{margin-left:10px;}
  .similarwrap .el-image{height:100px;width:100%;display:block;border-radius:4px;}
  .s-price{position:absolute;top:50px;left:0;right:0;height:20px;padding:23px 5px 7px;font-weight:700;background-image:linear-gradient(bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%);color:#F44336;border-radius:4px;}
  .s-house{color:#333;font-size:14px;padding-top:8px;font-weight:700;}
  .s-title{color:#999;font-size:12px;padding-top:2px;}
  .httax{float:right;}
  .si-tax{float:right;margin-top:0;}
  .si-tax b{display:inline;color:#F44336;line-height:20px;}
@media (max-width:768px){
  .popwrap{position:fixed;left:0;right:0;top:0;bottom:50px;z-index:11;}
  .popbox{width:100%;height:100%;}
  .el-icon-error{position:absolute;right:12px;top:12px;font-size:30px;z-index:3;cursor:pointer;color:#fff;opacity:0.8}
  .estateInfo{display:none;}
  .housetypedata >>> .guwenitem{margin-bottom:20px;}
}
@media (min-width:769px){
  /*.btitle{font-size:24px;margin-top:45px;}
  .btitle:before{height:30px;margin:0 11px 0 0;}
  .el-carousel{margin-top:25px;margin-bottom:-15px;}
  .detailPage >>> .el-carousel__container{height:240px;}
  .detailPage >>> .el-carousel .el-carousel__indicators--outside button{width:10px;height:10px;opacity:0.5;border-radius:50%;margin:0 5px;background-color:#ffd03d;}
  .detailPage >>> .el-carousel__indicator.is-active button{opacity:1}
  .guwenitem{border:1px solid #e9e9f2;background:#fff;border-radius:5px;padding:30px 50px 20px 160px;margin-top:25px;overflow:hidden;}
  .gwimg{width:100px;height:100px;top:50%;left:40px;margin-top:-50px;}
  .gwname{line-height:23px;margin-bottom:12px;}
  .gwname b{margin-right:10px;}
  .gwname em{background:#f1f1f1;padding:0 5px;font-size:12px;vertical-align:top;display:inline-block;font-style:normal;margin-left:8px;color:#333;border-radius:2px;}
  .gwservice{font-size:12px;color:#666;line-height:18px;margin-bottom:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
  .gwintro{color:#333;font-size:14px;line-height:20px;margin-right:20px;margin-bottom:10px;display:inline-block;}
  .gwintro em{color:inherit;}
  .sitem{display:inline-block;width:22.75%;margin-left:3%;line-height:20px;}
  .nomargin{margin-left:0;}
  .sitem .el-image{display:block;height:200px;border:1px solid #EBEEF5;border-radius:4px;}
  .si-title{font-size:16px;font-weight:700;margin-top:10px;display:inline-block;}
  .si-tprice{float:right;margin-top:8px;display:inline-block;}
  .si-area{margin-top:8px;display:inline-block;margin-left:5px;}*/
  .popwrap{position:fixed;background:rgba(0,0,0,0.5);left:0;right:0;top:0;bottom:0;z-index:11;}
  .popbox{position:absolute;width:90%;background:#fff;left:5%;top:50%;margin-top:-260px;height:520px;}
  .el-icon-error{position:absolute;right:-10px;top:-10px;font-size:30px;z-index:1;cursor:pointer;}
  .estateInfo{position:absolute;right:20px;top:40px;z-index:1;width:20%;}
  .estateInfo .etitle{font-size:18px;font-weight:700;}
  .estateInfo .ephone{color:#F44336;font-size:18px;font-weight:bold;line-height:20px;margin-top:10px;}
}
@media (min-width:1100px){
  .popbox{width:1000px;left:50%;margin-left:-500px;top:50%;margin-top:-280px;height:560px;}
}
</style>



// WEBPACK FOOTER //
// src/components/HouseType.vue